import _ImageViewer from './ImageViewer';

import './style/index.js';

export type { ImageViewerProps } from './ImageViewer';

export const ImageViewer = _ImageViewer;

export default ImageViewer;
